import React from 'react';
import { Icon } from './icons.jsx';
// Observabilidade Operacional — saúde da plataforma SaaS multitenant
const { useState, useEffect, useRef } = React;

const TENANT_HEALTH = [
  { id: 42,  name: 'Loja Exemplo Premium', status: 'saudavel', health: 86, latency: '94ms',  errors: 0, jobs: 0,  search: 'OK',   storage: 'OK',  plan: 'pro',   schema: 'loja_exemplo_premium' },
  { id: 77,  name: 'Tech Store Brasil',    status: 'alerta',   health: 72, latency: '212ms', errors: 4, jobs: 3,  search: 'OK',   storage: 'OK',  plan: 'basic', schema: 'tech_store_brasil' },
  { id: 103, name: 'Moda Clara',           status: 'critico',  health: 41, latency: '—',     errors: 8, jobs: 12, search: 'Falha',storage: 'OK',  plan: 'pro',   schema: 'moda_clara' },
  { id: 4,   name: 'Dona Clara Doces',     status: 'saudavel', health: 91, latency: '78ms',  errors: 0, jobs: 0,  search: 'OK',   storage: 'OK',  plan: 'basic', schema: 'dona_clara_doces' },
  { id: 9,   name: 'Oficina do Skate',     status: 'saudavel', health: 88, latency: '102ms', errors: 0, jobs: 1,  search: 'OK',   storage: 'OK',  plan: 'basic', schema: 'oficina_skate' },
  { id: 7,   name: 'Ferragens Pampulha',   status: 'alerta',   health: 65, latency: '340ms', errors: 2, jobs: 0,  search: 'OK',   storage: 'Warn',plan: 'basic', schema: 'ferragens_pampulha' },
];

const SERVICES = [
  { name: 'Django App',       icon: 'server',   status: 'operando', uptime: '99.98%', latency: '82ms',  lastCheck: 'Há 30s',  errors: 0 },
  { name: 'Postgres',         icon: 'database', status: 'operando', uptime: '99.99%', latency: '4ms',   lastCheck: 'Há 30s',  errors: 0 },
  { name: 'Redis',            icon: 'zap',      status: 'operando', uptime: '100%',   latency: '0.8ms', lastCheck: 'Há 30s',  errors: 0 },
  { name: 'Celery Worker',    icon: 'activity', status: 'operando', uptime: '99.82%', latency: '—',     lastCheck: 'Há 1min', errors: 0 },
  { name: 'Celery Beat',      icon: 'clock',    status: 'operando', uptime: '99.90%', latency: '—',     lastCheck: 'Há 1min', errors: 0 },
  { name: 'OpenSearch',       icon: 'search',   status: 'alerta',   uptime: '98.40%', latency: '145ms', lastCheck: 'Há 2min', errors: 3 },
  { name: 'Storage / R2',     icon: 'package',  status: 'operando', uptime: '100%',   latency: '28ms',  lastCheck: 'Há 30s',  errors: 0 },
  { name: 'API Pública',      icon: 'link',     status: 'operando', uptime: '99.95%', latency: '112ms', lastCheck: 'Há 30s',  errors: 1 },
  { name: 'Dashboard Tenants',icon: 'store',    status: 'operando', uptime: '99.91%', latency: '195ms', lastCheck: 'Há 30s',  errors: 0 },
  { name: 'Super Admin',      icon: 'shield',   status: 'operando', uptime: '100%',   latency: '88ms',  lastCheck: 'Há 30s',  errors: 0 },
];

const CELERY_TASKS = [
  { task: 'sync_bling_orders',         tenant: 'Loja Exemplo Premium', status: 'success', created: 'Há 2h',    duration: '4.2s', retries: 0, error: null },
  { task: 'reindex_products',          tenant: 'Tech Store Brasil',    status: 'running', created: 'Há 5min',  duration: '—',    retries: 0, error: null },
  { task: 'send_overdue_notification', tenant: 'Tech Store Brasil',    status: 'failure', created: 'Há 3 dias',duration: '0.1s', retries: 3, error: 'SMTPConnectionError' },
  { task: 'provision_tenant',          tenant: 'Moda Clara',           status: 'failure', created: 'Há 2 dias',duration: '12.4s',retries: 5, error: 'IntegrityError: NOT NULL' },
  { task: 'cleanup_orphan_files',      tenant: '—',                    status: 'pending', created: 'Há 1h',    duration: '—',    retries: 0, error: null },
  { task: 'sync_google_merchant',      tenant: 'Moda Clara',           status: 'retry',   created: 'Há 4h',    duration: '—',    retries: 2, error: '403 Forbidden' },
];

const ERRORS_DATA = [
  { ts: 'Hoje, 14:22', service: 'Django App',   tenant: 'Moda Clara',         endpoint: '/dashboard/orders/', status: 500, error: 'DoesNotExist: StoreSettings',traceId: 'trc_abc1', freq: 8 },
  { ts: 'Hoje, 14:18', service: 'API Pública',  tenant: 'Tech Store Brasil',  endpoint: '/api/v1/stock/',      status: 401, error: 'Token expired or revoked',  traceId: 'trc_abc2', freq: 3 },
  { ts: 'Hoje, 13:55', service: 'OpenSearch',   tenant: 'Moda Clara',         endpoint: 'index write',         status: 503, error: 'cluster_block_exception',   traceId: 'trc_abc3', freq: 12 },
  { ts: 'Ontem, 16:00',service: 'Celery Worker',tenant: 'Tech Store Brasil',  endpoint: 'send_email task',     status: 500, error: 'SMTPConnectionError',        traceId: 'trc_abc4', freq: 3 },
  { ts: 'Ontem, 14:30',service: 'Django App',   tenant: 'Ferragens Pampulha', endpoint: '/dashboard/',         status: 504, error: 'Gateway Timeout (upstream)', traceId: 'trc_abc5', freq: 2 },
];

const INCIDENTS_MOCK = [
  { id: 'INC-041', title: 'OpenSearch — cluster_block_exception (shard não alocado)', severity: 'alto',   status: 'ativo',       started: 'Hoje, 13:50', duration: '35min', component: 'OpenSearch',    tenants: ['Moda Clara','Tech Store Brasil'], desc: 'Shard primário não alocado — bloqueando escrita no índice' },
  { id: 'INC-040', title: 'Falha de provisionamento parcial — Moda Clara',            severity: 'critico',status: 'ativo',       started: 'Há 2 dias',   duration: '2d 3h', component: 'Django App',     tenants: ['Moda Clara'], desc: 'IntegrityError durante criação de StoreSettings — tenant parcialmente configurado' },
  { id: 'INC-039', title: 'Latência elevada — Ferragens Pampulha',                    severity: 'medio',  status: 'monitorando', started: 'Hoje, 10:00', duration: '4h',    component: 'Postgres',       tenants: ['Ferragens Pampulha'], desc: 'Lock de banco detectado — 340ms de latência média, possível query sem índice' },
  { id: 'INC-038', title: 'Token de integração expirado — Tech Store Brasil',         severity: 'baixo',  status: 'resolvido',   started: 'Ontem, 16:30',duration: '2h',    component: 'API Pública',    tenants: ['Tech Store Brasil'], desc: 'Token tiny_v3 expirado — cliente notificado para renovação' },
  { id: 'INC-037', title: 'SMTPConnectionError — notificações não entregues',         severity: 'medio',  status: 'resolvido',   started: 'Há 3 dias',   duration: '30min', component: 'Celery Worker',  tenants: ['Tech Store Brasil','Dona Clara Doces'], desc: 'Falha temporária no servidor SMTP — reprocessado manualmente' },
];

const SEV_CONFIG = {
  critico: { cls: 'danger',  label: 'Crítico' },
  alto:    { cls: 'danger',  label: 'Alto' },
  medio:   { cls: 'warning', label: 'Médio' },
  baixo:   { cls: 'neutral', label: 'Baixo' },
};
const INC_STATUS = {
  ativo:       { cls: 'danger',  label: 'Ativo' },
  monitorando: { cls: 'warning', label: 'Monitorando' },
  resolvido:   { cls: 'success', label: 'Resolvido' },
};

const TOP_ENDPOINTS = [
  { endpoint: '/dashboard/orders/',   p95: '380ms', p99: '820ms', avg: '145ms', calls: 1842 },
  { endpoint: '/api/v1/catalogue/',   p95: '290ms', p99: '640ms', avg: '112ms', calls: 930 },
  { endpoint: '/dashboard/products/', p95: '520ms', p99: '1.2s',  avg: '210ms', calls: 412 },
  { endpoint: '/dashboard/analytics/',p95: '890ms', p99: '2.1s',  avg: '340ms', calls: 280 },
];

// ── Drawer: Diagnóstico de Serviço ───────────────────────────────────────────
const ServiceDiagnosticDrawer = ({ open, svc, onClose, onToast }) => {
  const [checking,  setChecking]  = useState(false);
  const [lastCheck, setLastCheck] = useState(null);
  React.useEffect(() => { if (!open) { setChecking(false); setLastCheck(null); } }, [open]);
  if (!open || !svc) return null;

  const runCheck = () => {
    setChecking(true);
    setTimeout(() => {
      setChecking(false);
      const now = new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
      setLastCheck(now);
      onToast && onToast(`Checagem de ${svc.name} concluída`);
    }, 2000);
  };

  const RECS = {
    alerta:       ['Verificar logs de erro recentes', 'Checar conectividade com dependências', 'Considerar restart se o problema persistir'],
    indisponivel: ['Acionar equipe de plantão imediatamente', 'Verificar recursos do servidor', 'Restaurar a partir do último estado estável'],
  };
  const recs = RECS[svc.status] || ['Serviço operando normalmente', 'Manter monitoramento padrão'];

  return (
    <div onClick={checking ? undefined : onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(10,22,40,0.4)', backdropFilter: 'blur(3px)', zIndex: 9999, display: 'flex', alignItems: 'stretch', justifyContent: 'flex-end' }}>
      <div onClick={e => e.stopPropagation()} style={{ width: 500, background: 'var(--bg-elevated)', boxShadow: '-4px 0 32px rgba(0,0,0,0.18)', display: 'flex', flexDirection: 'column' }}>
        <div style={{ padding: '18px 22px 14px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 12, flexShrink: 0 }}>
          <div style={{ width: 36, height: 36, borderRadius: 8, background: svc.status === 'alerta' ? 'var(--warning-bg)' : svc.status === 'indisponivel' ? 'var(--danger-bg)' : 'var(--success-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Icon name="activity" size={16} style={{ color: svc.status === 'alerta' ? 'var(--warning)' : svc.status === 'indisponivel' ? 'var(--danger)' : 'var(--success)' }} />
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 700, fontSize: 15 }}>Diagnóstico: {svc.name}</div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>Uptime: {svc.uptime} · {lastCheck ? `Última checagem: ${lastCheck}` : svc.lastCheck}</div>
          </div>
          {!checking && <button className="icon-action" onClick={onClose}><Icon name="x" size={16} /></button>}
        </div>
        <div style={{ flex: 1, overflowY: 'auto', padding: '20px 22px', display: 'flex', flexDirection: 'column', gap: 18 }}>
          <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
            {[
              ['Status',         <span className={`badge ${svc.status === 'alerta' ? 'warning' : svc.status === 'indisponivel' ? 'danger' : 'success'}`}><span className="dot" />{svc.status}</span>],
              ['Latência',       svc.latency],
              ['Erros recentes', <span style={{ fontWeight: 600, color: svc.errors > 0 ? 'var(--danger)' : 'var(--success)' }}>{svc.errors} erro{svc.errors !== 1 ? 's' : ''}</span>],
              ['Uptime',         svc.uptime],
              ['Última checagem',lastCheck ? `Há pouco (${lastCheck})` : svc.lastCheck],
            ].map(([k, v]) => (
              <div key={k} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '11px 16px', borderBottom: '1px solid var(--border)', fontSize: 13 }}>
                <span style={{ color: 'var(--text-muted)', fontSize: 12 }}>{k}</span>
                <span>{v}</span>
              </div>
            ))}
          </div>
          <div>
            <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 10, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Recomendações</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {recs.map((r, i) => (
                <div key={i} style={{ display: 'flex', gap: 10, padding: '10px 12px', background: 'var(--bg-subtle)', borderRadius: 8, fontSize: 13, color: 'var(--text-secondary)', alignItems: 'flex-start' }}>
                  <div style={{ width: 20, height: 20, borderRadius: '50%', background: 'var(--info-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontSize: 10, fontWeight: 700, color: 'var(--info)', marginTop: 1 }}>{i + 1}</div>
                  {r}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div style={{ padding: '12px 22px', background: 'var(--bg-subtle)', display: 'flex', gap: 8, borderTop: '1px solid var(--border)', flexShrink: 0, alignItems: 'center' }}>
          {lastCheck && <span style={{ fontSize: 12, color: 'var(--success)', display: 'flex', alignItems: 'center', gap: 5 }}><Icon name="check" size={12} />Checado às {lastCheck}</span>}
          <button className="btn" style={{ marginLeft: 'auto' }} onClick={onClose}>Fechar</button>
          <button className="btn primary" onClick={runCheck} disabled={checking}>
            {checking ? <><div style={{ width: 12, height: 12, borderRadius: '50%', border: '2px solid rgba(255,255,255,.3)', borderTop: '2px solid white', animation: 'spin 0.8s linear infinite' }} />Checando…</> : <><Icon name="activity" size={13} />Executar nova checagem</>}
          </button>
        </div>
      </div>
    </div>
  );
};

// ── Modal: Postmortem ─────────────────────────────────────────────────────────
const PostmortemModal = ({ open, inc, onClose, onSave }) => {
  const EMPTY = { titulo: '', impacto: '', causaRaiz: '', timeline: '', acoesCorretivas: '', responsavel: '' };
  const [form,   setForm]   = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  const [saved,  setSaved]  = useState(false);
  React.useEffect(() => { if (!open) { setForm(EMPTY); setSaving(false); setSaved(false); } }, [open]);
  if (!open || !inc) return null;

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const isValid = form.titulo.trim() && form.causaRaiz.trim() && form.responsavel.trim();

  const handleSave = () => {
    if (!isValid) return;
    setSaving(true);
    setTimeout(() => { setSaving(false); setSaved(true); onSave && onSave(inc, form); }, 1200);
  };

  const Field = ({ k, label, multiline, placeholder }) => (
    <div>
      <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 5 }}>{label}</label>
      {multiline
        ? <textarea value={form[k]} onChange={e => set(k, e.target.value)} placeholder={placeholder} style={{ width: '100%', minHeight: 64, padding: '8px 12px', border: '1px solid var(--border-strong)', borderRadius: 8, background: 'var(--bg-elevated)', color: 'var(--text)', fontSize: 13, fontFamily: 'inherit', resize: 'vertical', lineHeight: 1.5 }} />
        : <input value={form[k]} onChange={e => set(k, e.target.value)} placeholder={placeholder} style={{ width: '100%', height: 36, padding: '0 12px', borderRadius: 8, border: '1px solid var(--border-strong)', background: 'var(--bg-elevated)', color: 'var(--text)', fontSize: 13, fontFamily: 'inherit' }} />
      }
    </div>
  );

  return (
    <div onClick={saving ? undefined : onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(10,22,40,0.44)', backdropFilter: 'blur(4px)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div onClick={e => e.stopPropagation()} style={{ width: 600, maxHeight: '90vh', background: 'var(--bg-elevated)', borderRadius: 16, boxShadow: 'var(--shadow-lg)', border: '1px solid var(--border)', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <div style={{ padding: '18px 22px 14px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 12, flexShrink: 0 }}>
          <div style={{ width: 36, height: 36, borderRadius: 8, background: 'var(--info-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Icon name="edit" size={16} style={{ color: 'var(--info)' }} /></div>
          <div style={{ flex: 1 }}><div style={{ fontWeight: 600, fontSize: 15 }}>Criar postmortem</div><div style={{ fontSize: 12, color: 'var(--text-muted)' }}>{inc.id} — {inc.component}</div></div>
          {!saving && <button className="icon-action" onClick={onClose}><Icon name="x" size={15} /></button>}
        </div>
        <div style={{ flex: 1, overflowY: 'auto', padding: '20px 22px', display: 'flex', flexDirection: 'column', gap: 14 }}>
          {saved && (
            <div style={{ padding: '10px 14px', background: 'var(--success-bg)', borderRadius: 8, fontSize: 13, color: 'var(--success)', display: 'flex', gap: 8, alignItems: 'center' }}>
              <Icon name="check" size={13} />Postmortem salvo · {inc.id}
            </div>
          )}
          <div style={{ padding: '10px 12px', background: 'var(--bg-subtle)', borderRadius: 8, fontSize: 12, color: 'var(--text-secondary)', display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            <span><strong>Incidente:</strong> {inc.id}</span><span>·</span>
            <span><strong>Componente:</strong> {inc.component}</span><span>·</span>
            <span><strong>Duração:</strong> {inc.duration}</span>
          </div>
          <Field k="titulo"          label="Título *"          placeholder="Ex.: OpenSearch — cluster_block_exception causou indisponibilidade" />
          <Field k="impacto"         label="Impacto"           placeholder="Quais serviços e tenants foram afetados…" multiline />
          <Field k="causaRaiz"       label="Causa raiz *"      placeholder="O que causou o incidente?" multiline />
          <Field k="timeline"        label="Timeline"          placeholder="13:50 — Alerta disparado&#10;14:00 — Investigação iniciada&#10;14:25 — Resolvido" multiline />
          <Field k="acoesCorretivas" label="Ações corretivas"  placeholder="O que faremos para evitar recorrência?" multiline />
          <Field k="responsavel"     label="Responsável *"      placeholder="Nome do responsável pelo postmortem" />
        </div>
        <div style={{ padding: '12px 22px', borderTop: '1px solid var(--border)', background: 'var(--bg-subtle)', display: 'flex', gap: 8, justifyContent: 'flex-end', flexShrink: 0 }}>
          <button className="btn ghost" onClick={onClose}>Fechar</button>
          <button className="btn primary" disabled={!isValid || saving} onClick={handleSave} style={{ opacity: isValid ? 1 : 0.5, minWidth: 140 }}>
            {saving ? <><div style={{ width: 12, height: 12, borderRadius: '50%', border: '2px solid rgba(255,255,255,.3)', borderTop: '2px solid white', animation: 'spin 0.8s linear infinite' }} />Salvando…</> : <><Icon name="check" size={13} />{saved ? 'Salvo ✓' : 'Salvar postmortem'}</>}
          </button>
        </div>
      </div>
    </div>
  );
};

// ── Modal: Exportar Incidente ─────────────────────────────────────────────────
const ExportIncidentModal = ({ open, inc, onClose, onToast }) => {
  const [format,   setFormat]   = useState('PDF');
  const [includes, setIncludes] = useState(['timeline', 'logs', 'metricas']);
  const [running,  setRunning]  = useState(false);
  const [done,     setDone]     = useState(false);
  const [fileName, setFileName] = useState('');
  React.useEffect(() => { if (!open) { setFormat('PDF'); setIncludes(['timeline', 'logs', 'metricas']); setRunning(false); setDone(false); } }, [open]);
  if (!open || !inc) return null;

  const toggleInclude = v => setIncludes(s => s.includes(v) ? s.filter(x => x !== v) : [...s, v]);

  const handleExport = () => {
    setRunning(true);
    setTimeout(() => {
      setRunning(false); setDone(true);
      const ext = format === 'Markdown' ? 'md' : format.toLowerCase();
      setFileName(`postmortem_${inc.id}_${new Date().toISOString().slice(0,10)}.${ext}`);
      onToast && onToast(`Exportação de ${inc.id} gerada`);
    }, 1800);
  };

  const OPTS = [['timeline','Timeline do incidente'],['logs','Logs relevantes'],['metricas','Métricas de impacto'],['tenants','Tenants afetados'],['postmortem','Postmortem (se existir)']];

  return (
    <div onClick={done || running ? undefined : onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(10,22,40,0.44)', backdropFilter: 'blur(4px)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div onClick={e => e.stopPropagation()} style={{ width: 480, background: 'var(--bg-elevated)', borderRadius: 16, boxShadow: 'var(--shadow-lg)', border: '1px solid var(--border)', overflow: 'hidden' }}>
        <div style={{ padding: '18px 22px 14px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{ width: 36, height: 36, borderRadius: 8, background: 'var(--info-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Icon name="download" size={16} style={{ color: 'var(--info)' }} /></div>
          <div style={{ flex: 1 }}><div style={{ fontWeight: 600, fontSize: 15 }}>Exportar incidente</div><div style={{ fontSize: 12, color: 'var(--text-muted)' }}>{inc.id} — {inc.component}</div></div>
          {!running && !done && <button className="icon-action" onClick={onClose}><Icon name="x" size={15} /></button>}
        </div>
        <div style={{ padding: '18px 22px', display: 'flex', flexDirection: 'column', gap: 16 }}>
          {!done && !running && (
            <>
              <div>
                <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 7 }}>Formato</div>
                <div style={{ display: 'flex', gap: 6 }}>
                  {['PDF', 'Markdown', 'JSON'].map(f => (
                    <button key={f} onClick={() => setFormat(f)} style={{ flex: 1, padding: '8px', borderRadius: 8, border: `1.5px solid ${format === f ? 'var(--brand-navy)' : 'var(--border)'}`, background: format === f ? 'var(--brand-navy)' : 'transparent', color: format === f ? 'white' : 'var(--text-secondary)', fontSize: 13, fontWeight: format === f ? 600 : 400, cursor: 'pointer', textAlign: 'center', transition: 'all 120ms' }}>{f}</button>
                  ))}
                </div>
              </div>
              <div>
                <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 7 }}>Incluir no export</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                  {OPTS.map(([v, l]) => (
                    <label key={v} style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', padding: '7px 10px', borderRadius: 6, border: '1px solid', borderColor: includes.includes(v) ? 'var(--brand-navy)' : 'var(--border)', background: includes.includes(v) ? 'color-mix(in srgb, var(--brand-navy) 8%, transparent)' : 'transparent', transition: 'all 120ms' }}>
                      <input type="checkbox" checked={includes.includes(v)} onChange={() => toggleInclude(v)} style={{ accentColor: 'var(--brand-navy)', flexShrink: 0 }} />
                      <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{l}</span>
                    </label>
                  ))}
                </div>
              </div>
            </>
          )}
          {running && (
            <div style={{ textAlign: 'center', padding: '24px 0' }}>
              <div style={{ width: 44, height: 44, borderRadius: '50%', border: '3px solid var(--border)', borderTop: '3px solid var(--brand-navy)', animation: 'spin 0.8s linear infinite', margin: '0 auto 16px' }} />
              <div style={{ fontWeight: 600 }}>Gerando exportação…</div>
            </div>
          )}
          {done && (
            <div style={{ textAlign: 'center', padding: '12px 0' }}>
              <div style={{ width: 52, height: 52, borderRadius: '50%', background: 'var(--success-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px' }}><Icon name="check" size={22} style={{ color: 'var(--success)' }} /></div>
              <div style={{ fontWeight: 700, fontSize: 15 }}>Exportação gerada</div>
              <div style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 4 }}>{format} · {inc.id}</div>
              <div style={{ marginTop: 16, padding: '10px 14px', background: 'var(--bg-subtle)', borderRadius: 8, display: 'flex', alignItems: 'center', gap: 10 }}>
                <Icon name="download" size={14} style={{ color: 'var(--text-muted)', flexShrink: 0 }} />
                <code style={{ flex: 1, fontSize: 11, fontFamily: 'JetBrains Mono, monospace', color: 'var(--text-secondary)', textAlign: 'left' }}>{fileName}</code>
                <button className="btn sm primary" onClick={() => onToast && onToast('Download iniciado (mock)')}><Icon name="download" size={12} />Baixar arquivo</button>
              </div>
            </div>
          )}
        </div>
        <div style={{ padding: '12px 22px', borderTop: '1px solid var(--border)', background: 'var(--bg-subtle)', display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          {!done && !running && <><button className="btn ghost" onClick={onClose}>Cancelar</button><button className="btn primary" onClick={handleExport}><Icon name="download" size={13} />Exportar</button></>}
          {done && <button className="btn primary" onClick={onClose}>Fechar</button>}
        </div>
      </div>
    </div>
  );
};

// ── Tab bar ──────────────────────────────────────────────────────────────────
const ObsTabs = ({ tabs, active, onChange }) => (
  <div style={{ display: 'flex', borderBottom: '1px solid var(--border)', marginBottom: 24, flexWrap: 'wrap' }}>
    {tabs.map(t => (
      <button key={t.id} onClick={() => onChange(t.id)} style={{
        padding: '8px 14px', border: 'none', background: 'transparent',
        fontSize: 12, fontWeight: active === t.id ? 600 : 500,
        color: active === t.id ? 'var(--text)' : 'var(--text-muted)',
        borderBottom: active === t.id ? '2px solid var(--brand-navy)' : '2px solid transparent',
        marginBottom: -1, cursor: 'pointer', transition: 'color 120ms', whiteSpace: 'nowrap',
      }}>
        {t.label}
        {t.badge && <span style={{ marginLeft: 5, fontSize: 10, fontWeight: 700, background: 'var(--danger)', color: 'white', padding: '1px 5px', borderRadius: 8 }}>{t.badge}</span>}
      </button>
    ))}
  </div>
);

// ── Export Report Modal ──────────────────────────────────────────────────────
const ExportRelatorioModal = ({ open, onClose, onToast, lastExport, setLastExport }) => {
  const [period,   setPeriod]   = useState('7d');
  const [scope,    setScope]    = useState('platform');
  const [format,   setFormat]   = useState('PDF');
  const [includes, setIncludes] = useState(['incidents','perf']);
  const [running,  setRunning]  = useState(false);
  const [done,     setDone]     = useState(false);

  if (!open) return null;

  const toggleInclude = v => setIncludes(s => s.includes(v) ? s.filter(x => x !== v) : [...s, v]);

  const handleExport = () => {
    setRunning(true);
    setTimeout(() => {
      setRunning(false);
      setDone(true);
      const now = new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
      setLastExport && setLastExport(now);
    }, 2200);
  };

  const handleClose = () => {
    setPeriod('7d'); setScope('platform'); setFormat('PDF'); setIncludes(['incidents','perf']);
    setRunning(false); setDone(false);
    onClose();
  };

  return (
    <div onClick={done ? undefined : handleClose} style={{ position: 'fixed', inset: 0, background: 'rgba(10,22,40,0.5)', backdropFilter: 'blur(4px)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div onClick={e => e.stopPropagation()} style={{ width: 500, background: 'var(--bg-elevated)', borderRadius: 16, boxShadow: 'var(--shadow-lg)', overflow: 'hidden', border: '1px solid var(--border)' }}>
        <div style={{ padding: '18px 22px 14px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{ width: 36, height: 36, borderRadius: 8, background: 'var(--info-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Icon name="download" size={17} style={{ color: 'var(--info)' }} />
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 700, fontSize: 15 }}>Exportar relatório</div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>Configure os dados a exportar</div>
          </div>
          {!running && !done && <button className="icon-action" onClick={handleClose}><Icon name="x" size={16} /></button>}
        </div>

        <div style={{ padding: '16px 22px' }}>
          {!running && !done && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 7 }}>Período</label>
                <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                  {[['24h','Últimas 24h'],['7d','Últimos 7 dias'],['30d','Últimos 30 dias'],['custom','Personalizado']].map(([v,l]) => (
                    <button key={v} onClick={() => setPeriod(v)} style={{ padding: '5px 12px', borderRadius: 6, border: '1px solid', borderColor: period===v ? 'var(--brand-navy)' : 'var(--border)', background: period===v ? 'var(--brand-navy)' : 'transparent', color: period===v ? 'white' : 'var(--text-secondary)', fontSize: 12, fontWeight: 500, cursor: 'pointer', transition: 'all 120ms' }}>{l}</button>
                  ))}
                </div>
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 7 }}>Escopo</label>
                <select className="select" style={{ width: '100%' }} value={scope} onChange={e => setScope(e.target.value)}>
                  <option value="platform">Plataforma inteira</option>
                  <option value="tenant">Tenant específico</option>
                  <option value="queues">Filas</option>
                  <option value="search">Busca</option>
                  <option value="storage">Storage</option>
                  <option value="jobs">Jobs</option>
                  <option value="integrations">Integrações</option>
                </select>
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 7 }}>Formato</label>
                <div style={{ display: 'flex', gap: 4 }}>
                  {['PDF','CSV','JSON'].map(f => (
                    <button key={f} onClick={() => setFormat(f)} style={{ padding: '5px 16px', borderRadius: 6, border: '1px solid', borderColor: format===f ? 'var(--brand-navy)' : 'var(--border)', background: format===f ? 'var(--brand-navy)' : 'transparent', color: format===f ? 'white' : 'var(--text-secondary)', fontSize: 12, fontWeight: 600, cursor: 'pointer', transition: 'all 120ms' }}>{f}</button>
                  ))}
                </div>
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 7 }}>Incluir</label>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
                  {[['incidents','Incidentes'],['perf','Métricas de performance'],['logs','Logs agregados'],['alerts','Alertas']].map(([v,l]) => (
                    <label key={v} style={{ display: 'flex', alignItems: 'center', gap: 7, cursor: 'pointer', padding: '6px 10px', borderRadius: 6, border: '1px solid', borderColor: includes.includes(v) ? 'var(--brand-navy)' : 'var(--border)', background: includes.includes(v) ? 'color-mix(in srgb, var(--brand-navy) 8%, transparent)' : 'transparent', transition: 'all 120ms' }}>
                      <input type="checkbox" checked={includes.includes(v)} onChange={() => toggleInclude(v)} style={{ accentColor: 'var(--brand-navy)', flexShrink: 0 }} />
                      <span style={{ fontSize: 12, color: 'var(--text-secondary)' }}>{l}</span>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          )}

          {running && (
            <div style={{ textAlign: 'center', padding: '28px 0' }}>
              <div style={{ width: 44, height: 44, borderRadius: '50%', border: '3px solid var(--border)', borderTop: '3px solid var(--brand-navy)', animation: 'spin 0.8s linear infinite', margin: '0 auto 16px' }} />
              <div style={{ fontWeight: 600 }}>Gerando relatório…</div>
              <div style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 4 }}>Coletando dados da plataforma</div>
            </div>
          )}

          {done && (
            <div style={{ textAlign: 'center', padding: '24px 0' }}>
              <div style={{ width: 52, height: 52, borderRadius: '50%', background: 'var(--success-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px' }}>
                <Icon name="check" size={22} style={{ color: 'var(--success)' }} />
              </div>
              <div style={{ fontWeight: 700, fontSize: 15 }}>Relatório gerado</div>
              <div style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 4 }}>
                {format} · {scope === 'platform' ? 'Plataforma inteira' : scope} · Última exportação: agora
              </div>
            </div>
          )}
        </div>

        <div style={{ padding: '12px 22px', background: 'var(--bg-subtle)', display: 'flex', gap: 8, justifyContent: 'flex-end', borderTop: '1px solid var(--border)' }}>
          {!done && !running && (
            <>
              <button className="btn" onClick={handleClose}>Cancelar</button>
              <button className="btn primary" onClick={handleExport}><Icon name="download" size={14} />Exportar</button>
            </>
          )}
          {done && <button className="btn primary" onClick={handleClose}><Icon name="check" size={14} />Concluído</button>}
        </div>
      </div>
    </div>
  );
};

// ── Configure Alerts Drawer ──────────────────────────────────────────────────
const ConfigAlertsDrawer = ({ open, onClose, onToast, logAction, setAlertsLastUpdated }) => {
  const DEFAULT_RULES = [
    { id: 'queue_delay',    label: 'Fila com atraso acima de', unit: 'min', threshold: 15, enabled: true,  severity: 'alto' },
    { id: 'errors_5xx',     label: 'Erro 5xx acima de',        unit: '%',   threshold: 5,  enabled: true,  severity: 'critico' },
    { id: 'latency',        label: 'Latência acima de',        unit: 'ms',  threshold: 500,enabled: true,  severity: 'medio' },
    { id: 'job_failure',    label: 'Falha em job crítico',     unit: null,  threshold: 1,  enabled: true,  severity: 'alto' },
    { id: 'storage',        label: 'Storage acima de',         unit: '%',   threshold: 80, enabled: false, severity: 'alto' },
    { id: 'opensearch_down',label: 'OpenSearch indisponível',  unit: null,  threshold: 1,  enabled: true,  severity: 'critico' },
    { id: 'integration_fail',label:'Integração com falha recorrente',unit:null,threshold:3,enabled: true,  severity: 'medio' },
  ];

  const [rules,    setRules]    = useState(DEFAULT_RULES);
  const [channels, setChannels] = useState(['bell','email']);
  const [saving,   setSaving]   = useState(false);
  const [saved,    setSaved]    = useState(false);

  if (!open) return null;

  const toggleChannel = v => setChannels(s => s.includes(v) ? s.filter(x => x !== v) : [...s, v]);
  const setRule = (id, key, val) => setRules(r => r.map(x => x.id === id ? { ...x, [key]: val } : x));

  const handleSave = () => {
    setSaving(true);
    setTimeout(() => {
      setSaving(false);
      setSaved(true);
      const now = new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
      setAlertsLastUpdated && setAlertsLastUpdated(now);
      logAction && logAction({ acao: 'Alertas de observabilidade atualizados', loja: '—', kind: 'info' });
      onToast && onToast('Alertas salvos com sucesso');
      setTimeout(() => { setSaved(false); onClose(); }, 800);
    }, 1200);
  };

  const handleRestore = () => {
    setRules(DEFAULT_RULES);
    onToast && onToast('Configurações restauradas para o padrão');
  };

  const SEV_OPTS = ['baixo','medio','alto','critico'];
  const SEV_COLORS = { baixo:'var(--info)', medio:'var(--warning)', alto:'var(--warning)', critico:'var(--danger)' };

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(10,22,40,0.4)', backdropFilter: 'blur(3px)', zIndex: 9999, display: 'flex', alignItems: 'stretch', justifyContent: 'flex-end' }}>
      <div onClick={e => e.stopPropagation()} style={{ width: 560, background: 'var(--bg-elevated)', boxShadow: '-4px 0 32px rgba(0,0,0,0.18)', display: 'flex', flexDirection: 'column' }}>
        <div style={{ padding: '18px 22px 14px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 12, flexShrink: 0 }}>
          <div style={{ width: 36, height: 36, borderRadius: 8, background: 'var(--warning-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Icon name="bell" size={17} style={{ color: 'var(--warning)' }} />
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 700, fontSize: 15 }}>Configurar alertas</div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>Defina limites e canais de notificação</div>
          </div>
          <button className="icon-action" onClick={onClose}><Icon name="x" size={16} /></button>
        </div>

        <div style={{ flex: 1, overflowY: 'auto', padding: '20px 22px' }}>
          {/* Alert rules */}
          <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 10 }}>Regras de alerta</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 22 }}>
            {rules.map(rule => (
              <div key={rule.id} style={{ padding: '10px 12px', background: rule.enabled ? 'var(--bg-elevated)' : 'var(--bg-subtle)', borderRadius: 8, border: '1px solid', borderColor: rule.enabled ? 'var(--border-strong)' : 'var(--border)', display: 'flex', alignItems: 'center', gap: 10, transition: 'all 150ms' }}>
                {/* Toggle */}
                <button onClick={() => setRule(rule.id,'enabled',!rule.enabled)} style={{ width: 32, height: 18, borderRadius: 9, background: rule.enabled ? 'var(--brand-navy)' : 'var(--bg-subtle)', border: `1px solid ${rule.enabled ? 'var(--brand-navy)' : 'var(--border-strong)'}`, cursor: 'pointer', position: 'relative', flexShrink: 0, transition: 'background 150ms' }}>
                  <span style={{ position: 'absolute', top: 2, left: rule.enabled ? 15 : 2, width: 12, height: 12, borderRadius: '50%', background: rule.enabled ? 'white' : 'var(--text-muted)', transition: 'left 150ms' }} />
                </button>
                {/* Label */}
                <span style={{ flex: 1, fontSize: 13, color: rule.enabled ? 'var(--text)' : 'var(--text-muted)' }}>{rule.label}</span>
                {/* Threshold */}
                {rule.unit && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    <input type="number" value={rule.threshold} onChange={e => setRule(rule.id,'threshold',Number(e.target.value))} disabled={!rule.enabled} style={{ width: 56, height: 28, padding: '0 6px', borderRadius: 6, border: '1px solid var(--border-strong)', background: 'var(--bg-elevated)', color: 'var(--text)', fontSize: 12, fontFamily: 'JetBrains Mono, monospace', textAlign: 'right', opacity: rule.enabled ? 1 : 0.4 }} />
                    <span style={{ fontSize: 11, color: 'var(--text-muted)', fontFamily: 'JetBrains Mono, monospace' }}>{rule.unit}</span>
                  </div>
                )}
                {/* Severity */}
                <select value={rule.severity} onChange={e => setRule(rule.id,'severity',e.target.value)} disabled={!rule.enabled} style={{ height: 28, padding: '0 6px', borderRadius: 6, border: '1px solid var(--border-strong)', background: 'var(--bg-elevated)', color: SEV_COLORS[rule.severity] || 'var(--text)', fontSize: 11, fontWeight: 600, opacity: rule.enabled ? 1 : 0.4, cursor: rule.enabled ? 'pointer' : 'default' }}>
                  {SEV_OPTS.map(s => <option key={s} value={s}>{s.charAt(0).toUpperCase() + s.slice(1)}</option>)}
                </select>
              </div>
            ))}
          </div>

          {/* Channels */}
          <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 10 }}>Canal de notificação</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 22 }}>
            {[['bell','Sino do Super Admin','Notificações internas na plataforma'],['email','E-mail','Envio para o e-mail do responsável'],['slack','Slack / Webhook (mockado)','POST para webhook configurado']].map(([v,l,desc]) => (
              <label key={v} style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', padding: '10px 12px', borderRadius: 8, border: '1px solid', borderColor: channels.includes(v) ? 'var(--brand-navy)' : 'var(--border)', background: channels.includes(v) ? 'color-mix(in srgb, var(--brand-navy) 6%, transparent)' : 'transparent', transition: 'all 120ms' }}>
                <input type="checkbox" checked={channels.includes(v)} onChange={() => toggleChannel(v)} style={{ accentColor: 'var(--brand-navy)', flexShrink: 0 }} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 13, fontWeight: 500, color: 'var(--text)' }}>{l}</div>
                  <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 1 }}>{desc}</div>
                </div>
              </label>
            ))}
          </div>

          {/* Active summary */}
          <div style={{ padding: '10px 12px', background: 'var(--bg-subtle)', borderRadius: 8, fontSize: 12, color: 'var(--text-secondary)' }}>
            <span style={{ fontWeight: 600 }}>{rules.filter(r => r.enabled).length}</span> regras ativas · <span style={{ fontWeight: 600 }}>{channels.length}</span> canal{channels.length !== 1 ? 'is' : ''} configurado{channels.length !== 1 ? 's' : ''}
          </div>
        </div>

        <div style={{ padding: '12px 22px', background: 'var(--bg-subtle)', display: 'flex', gap: 8, borderTop: '1px solid var(--border)', flexShrink: 0 }}>
          <button className="btn" onClick={handleRestore}><Icon name="refresh" size={13} />Restaurar padrão</button>
          <button className="btn" style={{ marginLeft: 'auto' }} onClick={onClose}>Cancelar</button>
          <button className="btn primary" onClick={handleSave} disabled={saving}>
            {saving ? <><div style={{ width: 13, height: 13, borderRadius: '50%', border: '2px solid rgba(255,255,255,.3)', borderTop: '2px solid white', animation: 'spin 0.8s linear infinite' }} />Salvando…</> : <><Icon name="check" size={14} />{saved ? 'Salvo!' : 'Salvar alertas'}</>}
          </button>
        </div>
      </div>
    </div>
  );
};

// ── Service Card ─────────────────────────────────────────────────────────────
const ServiceCard = ({ svc, onToast, onDiagnostic }) => {
  const isAlert = svc.status === 'alerta';
  const isDown  = svc.status === 'indisponivel';
  return (
    <div className="card" style={{ padding: 14, borderColor: isAlert ? 'var(--warning)' : isDown ? 'var(--danger)' : undefined }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
        <div style={{ width: 32, height: 32, borderRadius: 7, background: isAlert ? 'var(--warning-bg)' : isDown ? 'var(--danger-bg)' : 'var(--success-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <Icon name={svc.icon} size={15} style={{ color: isAlert ? 'var(--warning)' : isDown ? 'var(--danger)' : 'var(--success)' }} />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: 600, fontSize: 13 }}>{svc.name}</div>
          <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>Uptime: {svc.uptime}</div>
        </div>
        <span className={`badge ${isAlert ? 'warning' : isDown ? 'danger' : 'success'}`} style={{ fontSize: 10 }}><span className="dot" />{svc.status}</span>
      </div>
      <div style={{ display: 'flex', gap: 12, fontSize: 12 }}>
        <div><div style={{ color: 'var(--text-muted)' }}>Latência</div><div style={{ fontWeight: 600 }}>{svc.latency}</div></div>
        <div><div style={{ color: 'var(--text-muted)' }}>Erros</div><div style={{ fontWeight: 600, color: svc.errors > 0 ? 'var(--danger)' : 'var(--success)' }}>{svc.errors}</div></div>
        <div style={{ marginLeft: 'auto', textAlign: 'right' }}><div style={{ color: 'var(--text-muted)' }}>Checado</div><div style={{ fontWeight: 500 }}>{svc.lastCheck}</div></div>
      </div>
      {isAlert && (
        <button className="btn sm" style={{ marginTop: 10, width: '100%', justifyContent: 'center' }} onClick={() => onDiagnostic ? onDiagnostic(svc) : onToast && onToast(`Diagnóstico de ${svc.name} iniciado`)}>
          <Icon name="activity" size={12} />Ver diagnóstico
        </button>
      )}
    </div>
  );
};

const HealthScore = ({ score }) => {
  const color = score >= 80 ? 'var(--success)' : score >= 60 ? 'var(--warning)' : 'var(--danger)';
  return (
    <div style={{ width: 44, height: 44, borderRadius: '50%', border: `3px solid ${color}`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700, color, flexShrink: 0 }}>{score}</div>
  );
};

// ── Modal: Retry de Job ────────────────────────────────────────────────────
const RetryJobModal = ({ open, task, onClose, onConfirm }) => {
  const [step,    setStep]    = useState(0);
  const [outcome, setOutcome] = useState(null);
  React.useEffect(() => { if (!open) { setStep(0); setOutcome(null); } }, [open]);
  if (!open || !task) return null;
  const handleConfirm = () => {
    setStep(1);
    setTimeout(() => {
      const ok = Math.random() > 0.3;
      setOutcome(ok);
      setStep(2);
      onConfirm && onConfirm(task, ok);
    }, 2200);
  };
  return (
    <div onClick={step > 0 ? undefined : onClose} style={{ position:'fixed',inset:0,background:'rgba(10,22,40,0.44)',backdropFilter:'blur(4px)',zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center',padding:20 }}>
      <div onClick={e => e.stopPropagation()} style={{ width:460,background:'var(--bg-elevated)',borderRadius:16,boxShadow:'var(--shadow-lg)',border:'1px solid var(--border)',overflow:'hidden' }}>
        <div style={{ padding:'18px 22px 14px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:12 }}>
          <div style={{ width:36,height:36,borderRadius:8,background:'var(--info-bg)',display:'flex',alignItems:'center',justifyContent:'center' }}><Icon name="refresh" size={16} style={{ color:'var(--info)' }}/></div>
          <div style={{ flex:1 }}><div style={{ fontWeight:700,fontSize:15 }}>Retry de job</div><code style={{ fontSize:11,fontFamily:'JetBrains Mono, monospace',color:'var(--text-muted)' }}>{task.task}</code></div>
          {step === 0 && <button className="icon-action" onClick={onClose}><Icon name="x" size={15}/></button>}
        </div>
        <div style={{ padding:'18px 22px' }}>
          {step === 0 && <>
            {[['Task', <code key="t" style={{ fontFamily:'JetBrains Mono, monospace',fontSize:11 }}>{task.task}</code>], ['Tenant', task.tenant], ['Retries anteriores', task.retries], ['Último erro', task.error || '—']].map(([k, v]) => (
              <div key={k} style={{ display:'flex',justifyContent:'space-between',padding:'8px 0',borderBottom:'1px solid var(--border)',fontSize:13 }}>
                <span style={{ color:'var(--text-muted)',fontSize:12 }}>{k}</span>
                <span style={{ fontWeight:500, color: k==='Último erro'&&task.error ? 'var(--danger)' : 'inherit' }}>{v}</span>
              </div>
            ))}
          </>}
          {step === 1 && <div style={{ textAlign:'center',padding:'28px 0' }}>
            <div style={{ width:44,height:44,borderRadius:'50%',border:'3px solid var(--border)',borderTop:'3px solid var(--brand-navy)',animation:'spin 0.8s linear infinite',margin:'0 auto 16px' }}/>
            <div style={{ fontWeight:600,fontSize:14 }}>Reexecutando…</div>
            <div style={{ fontSize:12,color:'var(--text-muted)',marginTop:8 }}><code style={{ fontFamily:'JetBrains Mono, monospace',fontSize:11 }}>{task.task}</code></div>
          </div>}
          {step === 2 && <div style={{ textAlign:'center',padding:'28px 0' }}>
            <div style={{ width:52,height:52,borderRadius:'50%',background:outcome?'var(--success-bg)':'var(--danger-bg)',display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 14px' }}><Icon name={outcome?'check':'x'} size={22} style={{ color:outcome?'var(--success)':'var(--danger)' }}/></div>
            <div style={{ fontWeight:700,fontSize:15,color:outcome?'var(--success)':'var(--danger)' }}>{outcome ? 'Concluído!' : 'Falhou novamente'}</div>
            <div style={{ fontSize:13,color:'var(--text-muted)',marginTop:6 }}>Status: <strong>{outcome ? 'success' : 'failure'}</strong> · Atualizado agora</div>
          </div>}
        </div>
        <div style={{ padding:'12px 22px',borderTop:'1px solid var(--border)',background:'var(--bg-subtle)',display:'flex',gap:8,justifyContent:'flex-end' }}>
          {step === 0 && <><button className="btn ghost" onClick={onClose}>Cancelar</button><button className="btn primary" onClick={handleConfirm}><Icon name="refresh" size={13}/>Reexecutar job</button></>}
          {step === 2 && <button className="btn primary" onClick={onClose}><Icon name="check" size={13}/>Concluído</button>}
        </div>
      </div>
    </div>
  );
};

// ── Modal: Ação técnica genérica (cache, reindex) ────────────────────────────
const TechActionModal = ({ open, onClose, onConfirm, title, icon, iconBg, iconColor, body, progressLabel, successLabel }) => {
  const [step, setStep] = useState(0);
  React.useEffect(() => { if (!open) setStep(0); }, [open]);
  if (!open) return null;
  const handleConfirm = () => {
    setStep(1);
    setTimeout(() => { setStep(2); onConfirm && onConfirm(); }, 2000);
  };
  return (
    <div onClick={step > 0 ? undefined : onClose} style={{ position:'fixed',inset:0,background:'rgba(10,22,40,0.44)',backdropFilter:'blur(4px)',zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center',padding:20 }}>
      <div onClick={e => e.stopPropagation()} style={{ width:440,background:'var(--bg-elevated)',borderRadius:16,boxShadow:'var(--shadow-lg)',border:'1px solid var(--border)',overflow:'hidden' }}>
        <div style={{ padding:'18px 22px 14px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:12 }}>
          <div style={{ width:36,height:36,borderRadius:8,background:iconBg||'var(--info-bg)',display:'flex',alignItems:'center',justifyContent:'center' }}><Icon name={icon||'zap'} size={16} style={{ color:iconColor||'var(--info)' }}/></div>
          <div style={{ flex:1 }}><div style={{ fontWeight:700,fontSize:15 }}>{title}</div></div>
          {step === 0 && <button className="icon-action" onClick={onClose}><Icon name="x" size={15}/></button>}
        </div>
        <div style={{ padding:'18px 22px' }}>
          {step === 0 && <div style={{ fontSize:13,color:'var(--text-secondary)',lineHeight:1.7 }}>{body}</div>}
          {step === 1 && <div style={{ textAlign:'center',padding:'28px 0' }}>
            <div style={{ width:44,height:44,borderRadius:'50%',border:'3px solid var(--border)',borderTop:`3px solid ${iconColor||'var(--brand-navy)'}`,animation:'spin 0.8s linear infinite',margin:'0 auto 16px' }}/>
            <div style={{ fontWeight:600,fontSize:14 }}>{progressLabel||'Executando…'}</div>
          </div>}
          {step === 2 && <div style={{ textAlign:'center',padding:'28px 0' }}>
            <div style={{ width:52,height:52,borderRadius:'50%',background:iconBg||'var(--success-bg)',display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 14px' }}><Icon name="check" size={22} style={{ color:iconColor||'var(--success)' }}/></div>
            <div style={{ fontWeight:700,fontSize:15 }}>{successLabel||'Concluído!'}</div>
            <div style={{ fontSize:12,color:'var(--text-muted)',marginTop:6 }}>Atualizado às {new Date().toLocaleTimeString('pt-BR', { hour:'2-digit', minute:'2-digit' })}</div>
          </div>}
        </div>
        <div style={{ padding:'12px 22px',borderTop:'1px solid var(--border)',background:'var(--bg-subtle)',display:'flex',gap:8,justifyContent:'flex-end' }}>
          {step === 0 && <><button className="btn ghost" onClick={onClose}>Cancelar</button><button className="btn primary" onClick={handleConfirm}><Icon name={icon||'zap'} size={13}/>{title}</button></>}
          {step === 2 && <button className="btn primary" onClick={onClose}><Icon name="check" size={13}/>Concluído</button>}
        </div>
      </div>
    </div>
  );
};

// ── Modal: Limpar Órfãos ──────────────────────────────────────────────────────
const CleanOrphansModal = ({ open, count, onClose, onConfirm }) => {
  const [step, setStep] = useState(0);
  React.useEffect(() => { if (!open) setStep(0); }, [open]);
  if (!open) return null;
  const handleConfirm = () => { setStep(1); setTimeout(() => { setStep(2); onConfirm && onConfirm(); }, 2400); };
  return (
    <div onClick={step > 0 ? undefined : onClose} style={{ position:'fixed',inset:0,background:'rgba(10,22,40,0.44)',backdropFilter:'blur(4px)',zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center',padding:20 }}>
      <div onClick={e => e.stopPropagation()} style={{ width:440,background:'var(--bg-elevated)',borderRadius:16,boxShadow:'var(--shadow-lg)',border:'1px solid var(--border)',overflow:'hidden' }}>
        <div style={{ padding:'18px 22px 14px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:12 }}>
          <div style={{ width:36,height:36,borderRadius:8,background:'var(--warning-bg)',display:'flex',alignItems:'center',justifyContent:'center' }}><Icon name="trash" size={16} style={{ color:'var(--warning)' }}/></div>
          <div style={{ flex:1 }}><div style={{ fontWeight:700,fontSize:15 }}>Limpar arquivos órfãos</div></div>
          {step === 0 && <button className="icon-action" onClick={onClose}><Icon name="x" size={15}/></button>}
        </div>
        <div style={{ padding:'18px 22px' }}>
          {step === 0 && <>
            <div style={{ padding:'12px 14px',background:'var(--warning-bg)',borderRadius:8,marginBottom:16,fontSize:13,color:'var(--warning)',display:'flex',gap:8,alignItems:'flex-start' }}>
              <Icon name="alert" size={14} style={{ flexShrink:0,marginTop:1 }}/>
              <span><strong>{count}</strong> arquivo{count!==1?'s':''} órfão{count!==1?'s':''} encontrado{count!==1?'s':''}. Serão removidos permanentemente do storage.</span>
            </div>
            <div style={{ display:'flex',justifyContent:'space-between',padding:'9px 0',fontSize:13 }}>
              <span style={{ color:'var(--text-muted)',fontSize:12 }}>Arquivos a remover</span>
              <span style={{ fontWeight:700,color:'var(--warning)' }}>{count} arquivos</span>
            </div>
          </>}
          {step === 1 && <div style={{ textAlign:'center',padding:'28px 0' }}>
            <div style={{ width:44,height:44,borderRadius:'50%',border:'3px solid var(--border)',borderTop:'3px solid var(--warning)',animation:'spin 0.8s linear infinite',margin:'0 auto 16px' }}/>
            <div style={{ fontWeight:600 }}>Removendo arquivos órfãos…</div>
            <div style={{ fontSize:12,color:'var(--text-muted)',marginTop:6 }}>Verificando referências e limpando storage</div>
          </div>}
          {step === 2 && <div style={{ textAlign:'center',padding:'28px 0' }}>
            <div style={{ width:52,height:52,borderRadius:'50%',background:'var(--success-bg)',display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 14px' }}><Icon name="check" size={22} style={{ color:'var(--success)' }}/></div>
            <div style={{ fontWeight:700,fontSize:15 }}>Limpeza concluída!</div>
            <div style={{ fontSize:13,color:'var(--text-muted)',marginTop:6 }}>{count} arquivo{count!==1?'s':''} removido{count!==1?'s':''} · Órfãos: <strong>0</strong></div>
          </div>}
        </div>
        <div style={{ padding:'12px 22px',borderTop:'1px solid var(--border)',background:'var(--bg-subtle)',display:'flex',gap:8,justifyContent:'flex-end' }}>
          {step === 0 && <><button className="btn ghost" onClick={onClose}>Cancelar</button><button className="btn danger" onClick={handleConfirm}><Icon name="trash" size={13}/>Limpar {count} arquivo{count!==1?'s':''}</button></>}
          {step === 2 && <button className="btn primary" onClick={onClose}><Icon name="check" size={13}/>Concluído</button>}
        </div>
      </div>
    </div>
  );
};

// ── Modal: Testar Upload ──────────────────────────────────────────────────────
const TestUploadModal = ({ open, onClose, onToast }) => {
  const [testing, setTesting] = useState(false);
  const [result,  setResult]  = useState(null);
  React.useEffect(() => { if (!open) { setTesting(false); setResult(null); } }, [open]);
  if (!open) return null;
  const runTest = () => {
    setTesting(true); setResult(null);
    setTimeout(() => {
      const ok  = Math.random() > 0.15;
      const ms  = Math.floor(Math.random() * 700 + 180);
      const kb  = 256;
      setTesting(false);
      setResult({ ok, endpoint: 'https://cdn.tezus.com.br/upload/test', size: kb + ' KB', time: ms + 'ms', speed: Math.round(kb / (ms / 1000)) + ' KB/s', status: ok ? 200 : 500, ts: new Date().toLocaleTimeString('pt-BR', { hour:'2-digit', minute:'2-digit', second:'2-digit' }), bucket: 'tezus-storage-prod' });
      onToast && onToast(`Teste de upload: ${ok ? 'OK' : 'Falha'} · ${ms}ms`);
    }, 2400);
  };
  return (
    <div onClick={testing ? undefined : onClose} style={{ position:'fixed',inset:0,background:'rgba(10,22,40,0.44)',backdropFilter:'blur(4px)',zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center',padding:20 }}>
      <div onClick={e => e.stopPropagation()} style={{ width:500,background:'var(--bg-elevated)',borderRadius:16,boxShadow:'var(--shadow-lg)',border:'1px solid var(--border)',overflow:'hidden' }}>
        <div style={{ padding:'18px 22px 14px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:12 }}>
          <div style={{ width:36,height:36,borderRadius:8,background:'var(--info-bg)',display:'flex',alignItems:'center',justifyContent:'center' }}><Icon name="package" size={16} style={{ color:'var(--info)' }}/></div>
          <div style={{ flex:1 }}><div style={{ fontWeight:700,fontSize:15 }}>Testar upload</div><div style={{ fontSize:12,color:'var(--text-muted)' }}>Pipeline: endpoint → R2 → CDN</div></div>
          {!testing && <button className="icon-action" onClick={onClose}><Icon name="x" size={15}/></button>}
        </div>
        <div style={{ padding:'18px 22px' }}>
          {!result && !testing && <div style={{ fontSize:13,color:'var(--text-secondary)',lineHeight:1.7 }}>Fará upload de um arquivo de teste (256 KB) para o bucket de storage e verificará o pipeline completo.</div>}
          {testing && <div style={{ textAlign:'center',padding:'28px 0' }}>
            <div style={{ width:48,height:48,borderRadius:'50%',border:'3px solid var(--border)',borderTop:'3px solid var(--brand-navy)',animation:'spin 0.8s linear infinite',margin:'0 auto 16px' }}/>
            <div style={{ fontWeight:600,fontSize:14 }}>Executando teste de upload…</div>
            <div style={{ fontSize:12,color:'var(--text-muted)',marginTop:8 }}>Arquivo de teste · 256 KB</div>
          </div>}
          {result && <>
            <div style={{ padding:'12px 14px',background:result.ok?'var(--success-bg)':'var(--danger-bg)',borderRadius:10,marginBottom:16,display:'flex',alignItems:'center',gap:10,border:`1px solid color-mix(in srgb,${result.ok?'var(--success)':'var(--danger)'} 25%,transparent)` }}>
              <Icon name={result.ok?'check':'x'} size={18} style={{ color:result.ok?'var(--success)':'var(--danger)',flexShrink:0 }}/>
              <div>
                <div style={{ fontWeight:700,fontSize:13,color:result.ok?'var(--success)':'var(--danger)' }}>{result.ok ? 'Upload bem-sucedido' : 'Falha no upload'}</div>
                <div style={{ fontSize:11,opacity:.7,color:result.ok?'var(--success)':'var(--danger)',marginTop:1 }}>Verificado às {result.ts}</div>
              </div>
            </div>
            {[['Endpoint', <code key="ep" style={{ fontFamily:'JetBrains Mono, monospace',fontSize:10,color:'var(--text-muted)' }}>{result.endpoint}</code>], ['Bucket', <code key="bk" style={{ fontFamily:'JetBrains Mono, monospace',fontSize:11 }}>{result.bucket}</code>], ['Tamanho', result.size], ['Tempo de upload', <strong key="tm" style={{ color:result.ok?'var(--success)':'var(--danger)' }}>{result.time}</strong>], ['Velocidade', result.speed], ['Status HTTP', <code key="st" style={{ fontFamily:'JetBrains Mono, monospace',fontWeight:700,color:result.ok?'var(--success)':'var(--danger)' }}>{result.status}</code>]].map(([k, v]) => (
              <div key={k} style={{ display:'flex',justifyContent:'space-between',alignItems:'center',padding:'8px 0',borderBottom:'1px solid var(--border)',fontSize:13 }}>
                <span style={{ color:'var(--text-muted)',fontSize:12 }}>{k}</span><span style={{ fontWeight:500 }}>{v}</span>
              </div>
            ))}
          </>}
        </div>
        <div style={{ padding:'12px 22px',borderTop:'1px solid var(--border)',background:'var(--bg-subtle)',display:'flex',gap:8,justifyContent:'flex-end' }}>
          <button className="btn" onClick={onClose}>Fechar</button>
          <button className="btn primary" onClick={runTest} disabled={testing}>
            {testing ? <><div style={{ width:12,height:12,borderRadius:'50%',border:'2px solid rgba(255,255,255,.3)',borderTop:'2px solid white',animation:'spin 0.8s linear infinite' }}/>Testando…</> : <><Icon name="package" size={13}/>{result ? 'Executar novo teste' : 'Executar teste'}</>}
          </button>
        </div>
      </div>
    </div>
  );
};

// ── Observabilidade Page ─────────────────────────────────────────────────────
const ObservabilidadePage = ({ onToast, logAction, tenantContext }) => {
  const [tab,               setTab]               = useState('overview');
  const [exportOpen,        setExportOpen]        = useState(false);
  const [alertsOpen,        setAlertsOpen]        = useState(false);
  const [refreshing,        setRefreshing]        = useState(false);
  const [lastUpdated,       setLastUpdated]       = useState(null);
  const [lastExport,        setLastExport]        = useState(null);
  const [alertsLastUpdated, setAlertsLastUpdated] = useState(null);
  const [incidents,         setIncidents]         = useState(INCIDENTS_MOCK);
  const [incFilter,         setIncFilter]         = useState({ status: '', severity: '' });
  const [kpiVariant,        setKpiVariant]        = useState(0);
  const [diagnosticSvc,     setDiagnosticSvc]     = useState(null);
  const [postmortemInc,     setPostmortemInc]     = useState(null);
  const [exportInc,         setExportInc]         = useState(null);
  const [incLocalStates,    setIncLocalStates]    = useState({});
  const [retryJob,          setRetryJob]          = useState(null);
  const [clearCacheModal,   setClearCacheModal]   = useState(null); // { name, type }
  const [reindexModal,      setReindexModal]      = useState(null); // { name, tenantId }
  const [orphansModal,      setOrphansModal]      = useState(false);
  const [uploadModal,       setUploadModal]       = useState(false);
  const [celeryLocal,       setCeleryLocal]       = useState({});
  const [orphanCount,       setOrphanCount]       = useState(12);
  const [cacheCleared,      setCacheCleared]      = useState({});
  const [reindexDone,       setReindexDone]       = useState({});

  const TABS = [
    { id: 'overview',   label: 'Overview' },
    { id: 'incidentes', label: 'Incidentes', badge: incidents.filter(i => i.status === 'ativo').length || undefined },
    { id: 'tenants',    label: 'Tenants' },
    { id: 'servicos',   label: 'Serviços' },
    { id: 'celery',     label: 'Filas Celery' },
    { id: 'opensearch', label: 'Busca/OpenSearch' },
    { id: 'redis',      label: 'Cache/Redis' },
    { id: 'postgres',   label: 'Banco/Postgres' },
    { id: 'storage',    label: 'Storage/R2' },
    { id: 'errors',     label: 'Erros' },
    { id: 'perf',       label: 'Performance' },
  ];

  const handleRefresh = () => {
    setRefreshing(true);
    setTimeout(() => {
      setRefreshing(false);
      setKpiVariant(v => v + 1);
      const now = new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
      setLastUpdated(now);
      onToast && onToast('Dados atualizados');
    }, 1400);
  };

  // KPI values vary slightly on each refresh
  const kpiVariations = [
    [4, 3, 5, 4, 2],   // tenants saudaveis
    [2, 3, 1, 2, 3],   // tenants com alerta
    [8, 6, 11, 7, 9],  // erros 5xx
    [15, 12, 18, 14, 16], // celery pendentes
  ];
  const vi = kpiVariant % 5;

  const kpis = [
    { label: 'Status geral',         value: 'Operando',                  icon: 'activity', ok: true },
    { label: 'Tenants saudáveis',    value: kpiVariations[0][vi],         icon: 'store' },
    { label: 'Tenants com alerta',   value: kpiVariations[1][vi],         icon: 'alert', warn: true },
    { label: 'Erros 5xx (24h)',      value: kpiVariations[2][vi],         icon: 'x', danger: true },
    { label: 'Jobs pendentes',       value: kpiVariations[3][vi],         icon: 'clock', warn: true },
    { label: 'Latência média',       value: '134ms',                      icon: 'zap' },
    { label: 'OpenSearch',           value: 'Alerta',                     icon: 'search', warn: true },
    { label: 'Redis',                value: 'OK',                         icon: 'zap', ok: true },
    { label: 'Storage/R2',           value: 'OK',                         icon: 'package', ok: true },
  ];

  const filteredIncidents = incidents.filter(i =>
    (!incFilter.status   || i.status === incFilter.status) &&
    (!incFilter.severity || i.severity === incFilter.severity)
  );

  const markResolved = (id) => {
    setIncidents(prev => prev.map(i => i.id === id ? { ...i, status: 'resolvido' } : i));
    onToast && onToast('Incidente marcado como resolvido');
    logAction && logAction({ acao: `Incidente ${id} marcado como resolvido`, loja: '—', kind: 'info' });
  };

  return (
    <div className="content wide" style={{ maxWidth: 1280 }}>
      {tenantContext && (
        <div style={{ background: 'color-mix(in srgb, var(--info) 8%, var(--bg-elevated))', border: '1px solid color-mix(in srgb, var(--info) 30%, var(--border))', borderRadius: 10, padding: '10px 16px', marginBottom: 16, display: 'flex', alignItems: 'center', gap: 10 }}>
          <Icon name="activity" size={15} style={{ color: 'var(--info)', flexShrink: 0 }} />
          <span style={{ fontSize: 13, fontWeight: 600 }}>Logs filtrados para {tenantContext.name}</span>
          <code style={{ fontSize: 11, fontFamily: 'JetBrains Mono, monospace', color: 'var(--text-muted)', marginLeft: 4 }}>/admin/observability?tenant_id={tenantContext.id}</code>
        </div>
      )}

      <div className="page-header">
        <div>
          <h1>Observabilidade</h1>
          <p className="sub">Saúde operacional da plataforma, filas, busca, storage e performance.</p>
        </div>
        <div className="actions">
          {lastExport && <span style={{ fontSize: 11, color: 'var(--text-muted)', alignSelf: 'center' }}>Última exportação: {lastExport}</span>}
          <button className="btn" onClick={() => setExportOpen(true)}><Icon name="download" size={14} />Exportar relatório</button>
          {alertsLastUpdated && <span style={{ fontSize: 11, color: 'var(--text-muted)', alignSelf: 'center' }}>Alertas: {alertsLastUpdated}</span>}
          <button className="btn" onClick={() => setAlertsOpen(true)}><Icon name="bell" size={14} />Configurar alertas</button>
          <button className="btn" onClick={() => setTab('incidentes')}><Icon name="alert" size={14} />Incidentes {incidents.filter(i=>i.status==='ativo').length > 0 && <span style={{ marginLeft:2, fontWeight:700, color:'var(--danger)', fontSize:12 }}>({incidents.filter(i=>i.status==='ativo').length})</span>}</button>
          <button className="btn primary" onClick={handleRefresh} disabled={refreshing}>
            {refreshing
              ? <><div style={{ width: 13, height: 13, borderRadius: '50%', border: '2px solid rgba(255,255,255,.3)', borderTop: '2px solid white', animation: 'spin 0.8s linear infinite' }} />Atualizando…</>
              : <><Icon name="refresh" size={14} />Atualizar</>
            }
          </button>
        </div>
      </div>

      {/* KPI row */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(9, 1fr)', gap: 10, marginBottom: 24 }}>
        {kpis.map(k => (
          <div key={k.label} className="kpi" style={{ padding: '12px 14px', opacity: refreshing ? 0.5 : 1, transition: 'opacity 300ms' }}>
            <div className="label" style={{ fontSize: 11 }}><Icon name={k.icon} size={12} />{k.label}</div>
            <div className="value" style={{ fontSize: 18, marginTop: 6, color: k.danger ? 'var(--danger)' : k.warn ? 'var(--warning)' : k.ok ? 'var(--success)' : undefined }}>
              {refreshing ? '…' : k.value}
            </div>
          </div>
        ))}
      </div>

      {lastUpdated && (
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginBottom: 12, fontSize: 12, color: 'var(--success)', background: 'var(--success-bg)', padding: '3px 10px', borderRadius: 20 }}>
          <Icon name="check" size={12} />Atualizado às {lastUpdated}
        </div>
      )}

      <ObsTabs tabs={TABS} active={tab} onChange={setTab} />

      {/* ── Incidentes tab ── */}
      {tab === 'incidentes' && (
        <div>
          <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: 16, flexWrap: 'wrap' }}>
            <select className="select" value={incFilter.status} onChange={e => setIncFilter(f => ({...f, status: e.target.value}))}>
              <option value="">Todos os status</option>
              <option value="ativo">Ativo</option>
              <option value="monitorando">Monitorando</option>
              <option value="resolvido">Resolvido</option>
            </select>
            <select className="select" value={incFilter.severity} onChange={e => setIncFilter(f => ({...f, severity: e.target.value}))}>
              <option value="">Toda severidade</option>
              <option value="critico">Crítico</option>
              <option value="alto">Alto</option>
              <option value="medio">Médio</option>
              <option value="baixo">Baixo</option>
            </select>
            <span style={{ fontSize: 12, color: 'var(--text-muted)', marginLeft: 'auto' }}>{filteredIncidents.length} incidente{filteredIncidents.length !== 1 ? 's' : ''}</span>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {filteredIncidents.map(inc => {
              const sev = SEV_CONFIG[inc.severity] || SEV_CONFIG.baixo;
              const st  = INC_STATUS[inc.status]  || INC_STATUS.resolvido;
              return (
                <div key={inc.id} className="card" style={{ padding: 16, borderLeft: `3px solid ${inc.status === 'ativo' ? 'var(--danger)' : inc.status === 'monitorando' ? 'var(--warning)' : 'var(--border)'}` }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12, marginBottom: 10 }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4, flexWrap: 'wrap' }}>
                        <code style={{ fontSize: 11, fontFamily: 'JetBrains Mono, monospace', color: 'var(--text-muted)', background: 'var(--bg-subtle)', padding: '1px 6px', borderRadius: 4 }}>{inc.id}</code>
                        <span className={`badge ${sev.cls}`}><span className="dot" />{sev.label}</span>
                        <span className={`badge ${st.cls}`}><span className="dot" />{st.label}</span>
                        {incLocalStates[inc.id]?.postmortem && <span className="badge info" style={{ fontSize: 10 }}><span className="dot" />Postmortem criado</span>}
                      </div>
                      <div style={{ fontWeight: 600, fontSize: 14, lineHeight: 1.3 }}>{inc.title}</div>
                      <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 4 }}>{inc.desc}</div>
                    </div>
                    <div style={{ textAlign: 'right', flexShrink: 0 }}>
                      <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>Início: {inc.started}</div>
                      <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>Duração: {inc.duration}</div>
                    </div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                    <span style={{ fontSize: 11, background: 'var(--bg-subtle)', color: 'var(--text-secondary)', padding: '2px 8px', borderRadius: 4 }}>{inc.component}</span>
                    {inc.tenants.map(t => <span key={t} style={{ fontSize: 11, background: 'var(--info-bg)', color: 'var(--info)', padding: '2px 8px', borderRadius: 4 }}>{t}</span>)}
                    <div style={{ marginLeft: 'auto', display: 'flex', gap: 6 }}>
                      {inc.status !== 'resolvido' && (
                        <button className="btn sm" onClick={() => markResolved(inc.id)}><Icon name="check" size={12} />Marcar resolvido</button>
                      )}
                      <button className="btn sm" onClick={() => setPostmortemInc(inc)}><Icon name="edit" size={12} />Postmortem</button>
                      <button className="btn sm" onClick={() => setExportInc(inc)}><Icon name="download" size={12} /></button>
                    </div>
                  </div>
                </div>
              );
            })}
            {filteredIncidents.length === 0 && (
              <div className="hint-card" style={{ padding: '28px 20px', justifyContent: 'center', flexDirection: 'column', textAlign: 'center', gap: 10 }}>
                <Icon name="check" size={28} style={{ color: 'var(--success)', opacity: 0.5 }} />
                <div style={{ fontWeight: 500 }}>Nenhum incidente encontrado</div>
                <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>Ajuste os filtros ou aguarde novos eventos</div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ── Overview tab ── */}
      {tab === 'overview' && (
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 20 }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div className="card">
              <div className="card-head"><h3>Top tenants com mais erros</h3></div>
              <div className="card-body" style={{ padding: 0 }}>
                {TENANT_HEALTH.filter(t => t.errors > 0).sort((a,b) => b.errors - a.errors).map(t => (
                  <div key={t.id} style={{ padding: '12px 20px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 12 }}>
                    <HealthScore score={t.health} />
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 600, fontSize: 13 }}>{t.name}</div>
                      <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>{t.schema}</div>
                    </div>
                    <span className="badge danger"><span className="dot" />{t.errors} erros</span>
                    <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>{t.jobs} jobs pendentes</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="card">
              <div className="card-head"><h3>Top endpoints lentos</h3></div>
              <div className="card-body" style={{ padding: 0 }}>
                {TOP_ENDPOINTS.map((ep, i) => (
                  <div key={i} style={{ padding: '10px 20px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 12 }}>
                    <code style={{ fontSize: 12, fontFamily: 'JetBrains Mono, monospace', color: 'var(--text-secondary)', flex: 1 }}>{ep.endpoint}</code>
                    <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>avg <strong style={{ color: 'var(--text)' }}>{ep.avg}</strong></span>
                    <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>p99 <strong style={{ color: 'var(--warning)' }}>{ep.p99}</strong></span>
                    <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>{ep.calls} req</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div className="card">
              <div className="card-head"><h3>Alertas ativos</h3></div>
              <div className="alert-list">
                {[
                  { type:'danger',  icon:'alert', title:'Moda Clara — 8 erros 5xx',         meta:'Falha de provisionamento detectada' },
                  { type:'warning', icon:'clock', title:'OpenSearch com latência alta',      meta:'145ms de média · 3 erros' },
                  { type:'warning', icon:'alert', title:'Tech Store Brasil — 4 erros',       meta:'Token de integração expirado' },
                  { type:'warning', icon:'clock', title:'Ferragens Pampulha — lento',        meta:'340ms · possível lock de DB' },
                ].map((a,i) => (
                  <div key={i} className="alert-row">
                    <div className={`alert-icon ${a.type}`}><Icon name={a.icon} size={16} /></div>
                    <div className="alert-body"><div className="alert-title">{a.title}</div><div className="alert-meta">{a.meta}</div></div>
                    <Icon name="chevronRight" size={16} className="alert-action" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {tab === 'tenants' && (
        <div className="table-wrap">
          <div className="table-toolbar">
            <div className="search"><Icon name="search" size={15} /><input placeholder="Buscar tenant…" /></div>
            <select className="select"><option>Todos os status</option><option>Saudável</option><option>Alerta</option><option>Crítico</option></select>
          </div>
          <table className="data">
            <thead><tr><th>Tenant</th><th>Health</th><th>Status</th><th>Latência</th><th>Erros 5xx</th><th>Jobs</th><th>Busca</th><th>Storage</th><th style={{ textAlign:'right' }}>Ações</th></tr></thead>
            <tbody>
              {TENANT_HEALTH.map(t => (
                <tr key={t.id}>
                  <td><div style={{ fontWeight: 600 }}>{t.name}</div><div style={{ fontSize: 11, fontFamily: 'JetBrains Mono, monospace', color: 'var(--text-muted)' }}>{t.schema}</div></td>
                  <td><HealthScore score={t.health} /></td>
                  <td><span className={`badge ${t.status==='saudavel'?'success':t.status==='alerta'?'warning':'danger'}`}><span className="dot" />{t.status}</span></td>
                  <td style={{ fontFamily: 'JetBrains Mono, monospace', fontWeight: 500 }}>{t.latency}</td>
                  <td style={{ fontWeight: 600, color: t.errors > 0 ? 'var(--danger)' : 'var(--success)' }}>{t.errors}</td>
                  <td style={{ fontWeight: 600, color: t.jobs > 0 ? 'var(--warning)' : 'var(--text-muted)' }}>{t.jobs}</td>
                  <td><span className={`badge ${t.search==='OK'?'success':'danger'}`}><span className="dot" />{t.search}</span></td>
                  <td><span className={`badge ${t.storage==='OK'?'success':'warning'}`}><span className="dot" />{t.storage}</span></td>
                  <td>
                    <div className="row-actions">
                      <button className="icon-action" title="Diagnóstico" onClick={() => onToast && onToast(`Diagnóstico de ${t.name} iniciado`)}><Icon name="activity" size={13} /></button>
                      <button className="icon-action" title="Limpar cache" onClick={() => setClearCacheModal({ name: t.name, type: 'tenant' })}><Icon name="zap" size={13} /></button>
                      <button className="icon-action" title="Reindexar" onClick={() => setReindexModal({ name: t.name, tenantId: t.id })}><Icon name="search" size={13} /></button>
                      <button className="icon-action" title="Cockpit"><Icon name="dashboard" size={13} /></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {tab === 'servicos' && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 14 }}>
          {SERVICES.map(svc => <ServiceCard key={svc.name} svc={svc} onToast={onToast} onDiagnostic={setDiagnosticSvc} />)}
        </div>
      )}

      {tab === 'celery' && (
        <div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 12, marginBottom: 20 }}>
            {[{label:'Workers ativos',value:4,icon:'server'},{label:'Tarefas pendentes',value:15,icon:'clock',warn:true},{label:'Com falha',value:2,icon:'x',danger:true},{label:'Em retry',value:1,icon:'refresh',warn:true},{label:'Tempo médio',value:'4.2s',icon:'activity'}].map(k => (
              <div key={k.label} className="kpi"><div className="label"><Icon name={k.icon} size={14} />{k.label}</div><div className="value" style={{ fontSize: 22, color: k.danger ? 'var(--danger)' : k.warn ? 'var(--warning)' : undefined }}>{k.value}</div></div>
            ))}
          </div>
          <div className="table-wrap">
            <table className="data">
              <thead><tr><th>Task</th><th>Tenant</th><th>Status</th><th>Criada</th><th>Duração</th><th>Retries</th><th>Erro</th><th style={{ textAlign:'right' }}>Ações</th></tr></thead>
              <tbody>
              {CELERY_TASKS.map((t,i) => {
                const taskKey = t.task + '|' + t.tenant;
                const over    = celeryLocal[taskKey] || {};
                const st      = over.status || t.status;
                return (
                  <tr key={i}>
                    <td><code style={{ fontSize: 12, fontFamily: 'JetBrains Mono, monospace' }}>{t.task}</code></td>
                    <td>{t.tenant}</td>
                    <td><span className={`badge ${st==='success'?'success':st==='running'?'info':st==='pending'?'neutral':st==='retry'?'warning':'danger'}`}><span className="dot" />{st}</span></td>
                    <td style={{ fontSize: 12, color: 'var(--text-muted)' }}>{t.created}</td>
                    <td style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: 12 }}>{t.duration}</td>
                    <td style={{ fontWeight: t.retries > 0 ? 600 : 400, color: t.retries > 0 ? 'var(--warning)' : 'var(--text-muted)' }}>{t.retries}</td>
                    <td style={{ fontSize: 12, color: 'var(--danger)', maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{st === 'success' ? '—' : (t.error || '—')}</td>
                    <td>
                      <div className="row-actions">
                        {(st === 'failure' || st === 'retry') && <button className="icon-action" title="Retry" onClick={() => setRetryJob(t)}><Icon name="refresh" size={13} /></button>}
                        <button className="icon-action" title="Ver payload"><Icon name="terminal" size={13} /></button>
                        {st !== 'success' && <button className="icon-action danger" title="Cancelar"><Icon name="x" size={13} /></button>}
                      </div>
                    </td>
                  </tr>
                );
              })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {tab === 'opensearch' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
          <div className="card">
            <div className="card-head"><h3>Cluster OpenSearch</h3><span className="badge warning" style={{ marginLeft:'auto' }}><span className="dot" />Alerta</span></div>
            <div className="card-body">
              <div className="info-list">
                {[['Status cluster','yellow (1 shard não alocado)'],['Índices','8 ativos'],['Latência de busca','145ms avg'],['Latência de escrita','220ms avg'],['Erros recentes','3 (503 cluster_block)']].map(([l,v]) => (
                  <div key={l} className="info-row"><span className="label">{l}</span><span className="value">{v}</span></div>
                ))}
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-head"><h3>Índices por tenant</h3></div>
            <div className="card-body" style={{ padding: 0 }}>
              {TENANT_HEALTH.map(t => (
                <div key={t.id} style={{ padding: '10px 20px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 12 }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 13, fontWeight: 500 }}>{t.name}</div>
                    <code style={{ fontSize: 11, fontFamily: 'JetBrains Mono, monospace', color: 'var(--text-muted)' }}>idx_{t.schema}</code>
                  </div>
                  <span className={`badge ${t.search==='OK'?'success':'danger'}`}><span className="dot" />{t.search}</span>
                    <button className="icon-action" title="Reindexar" onClick={() => setReindexModal({ name: t.name, tenantId: t.id })}><Icon name="refresh" size={13} /></button>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {tab === 'redis' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
          <div className="card">
            <div className="card-head"><h3>Status Redis</h3><span className="badge success" style={{ marginLeft:'auto' }}><span className="dot" />Operando</span></div>
            <div className="card-body">
              <div className="info-list">
                {[['Uso de memória','1.2 GB / 4 GB'],['Hit rate','94.8%'],['Evictions','12'],['Conexões ativas','24'],['Slow commands','0']].map(([l,v]) => (
                  <div key={l} className="info-row"><span className="label">{l}</span><span className="value">{v}</span></div>
                ))}
              </div>
              <div style={{ marginTop: 14 }}>
                <button className="btn sm" onClick={() => setClearCacheModal({ name: 'Redis Global', type: 'global' })}><Icon name="zap" size={12} />Limpar cache global</button>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-head"><h3>Chaves por tenant</h3></div>
            <div className="card-body" style={{ padding: 0 }}>
              {TENANT_HEALTH.map((t,i) => {
                const keys = [812,344,128,290,156,440][i] || 100;
                return (
                  <div key={t.id} style={{ padding: '10px 20px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 12 }}>
                    <div style={{ flex: 1, fontSize: 13 }}>{t.name}</div>
                    <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>{keys} chaves</span>
                    <button className="icon-action" title="Limpar cache" onClick={() => setClearCacheModal({ name: t.name, type: 'tenant' })}><Icon name="zap" size={13} /></button>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {tab === 'postgres' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
          <div className="card">
            <div className="card-head"><h3>Conexões e performance</h3></div>
            <div className="card-body">
              <div className="info-list">
                {[['Conexões ativas','18/100'],['Queries lentas (>1s)','2'],['Migrations pendentes','0'],['Deadlocks (24h)','0'],['Locks ativos','1']].map(([l,v]) => (
                  <div key={l} className="info-row"><span className="label">{l}</span><span className="value">{v}</span></div>
                ))}
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-head"><h3>Tamanho por schema</h3></div>
            <div className="card-body" style={{ padding: 0 }}>
              {TENANT_HEALTH.map((t,i) => {
                const size = [42,18,8,34,12,28][i] || 10;
                return (
                  <div key={t.id} style={{ padding: '10px 20px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 12 }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 13 }}>{t.name}</div>
                      <code style={{ fontSize: 11, fontFamily: 'JetBrains Mono, monospace', color: 'var(--text-muted)' }}>{t.schema}</code>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <div style={{ fontSize: 13, fontWeight: 600 }}>{size} MB</div>
                      <div style={{ width: 60, height: 4, background: 'var(--bg-subtle)', borderRadius: 3, overflow: 'hidden', marginTop: 4 }}>
                        <div style={{ height: '100%', width: `${(size/50)*100}%`, background: 'var(--brand-navy)', borderRadius: 3 }} />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {tab === 'storage' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
          <div className="card">
            <div className="card-head"><h3>Storage / R2</h3><span className="badge success" style={{ marginLeft:'auto' }}><span className="dot" />Operando</span></div>
            <div className="card-body">
              <div className="info-list">
                {[['Uso total','38.4 GB / 500 GB'],['Arquivos órfãos','12'],['Uploads com falha','0'],['Domínio CDN','cdn.tezus.com.br'],['Última verificação','Há 2h']].map(([l,v]) => (
                  <div key={l} className="info-row"><span className="label">{l}</span><span className="value">{v}</span></div>
                ))}
              </div>
              <div style={{ marginTop: 14, display: 'flex', gap: 8 }}>
                <button className="btn sm" onClick={() => setOrphansModal(true)}><Icon name="trash" size={12} />Limpar órfãos ({orphanCount})</button>
                <button className="btn sm" onClick={() => setUploadModal(true)}><Icon name="package" size={12} />Testar upload</button>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-head"><h3>Uso por tenant</h3></div>
            <div className="card-body" style={{ padding: 0 }}>
              {TENANT_HEALTH.map((t,i) => {
                const gb = [12.4,8.2,6.1,5.8,3.2,2.7][i] || 1;
                const pct = Math.round((gb/50)*100);
                return (
                  <div key={t.id} style={{ padding: '12px 20px', borderBottom: '1px solid var(--border)' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 6 }}>
                      <span>{t.name}</span>
                      <span style={{ fontWeight: 600 }}>{gb} GB</span>
                    </div>
                    <div className="usage-bar"><div className="fill" style={{ width: `${pct}%` }} /></div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {tab === 'errors' && (
        <div className="table-wrap">
          <div className="table-toolbar">
            <div className="search"><Icon name="search" size={15} /><input placeholder="Buscar por erro, tenant, endpoint…" /></div>
            <select className="select"><option>Todos os serviços</option><option>Django App</option><option>Celery</option><option>OpenSearch</option></select>
          </div>
          <table className="data">
            <thead><tr><th>Data/hora</th><th>Serviço</th><th>Tenant</th><th>Endpoint</th><th>Status</th><th>Erro</th><th>Trace ID</th><th>Freq.</th><th style={{ textAlign:'right' }}>Ações</th></tr></thead>
            <tbody>
              {ERRORS_DATA.map((e,i) => (
                <tr key={i}>
                  <td style={{ fontSize: 12, color: 'var(--text-muted)', whiteSpace: 'nowrap' }}>{e.ts}</td>
                  <td style={{ fontSize: 13 }}>{e.service}</td>
                  <td style={{ fontWeight: 500 }}>{e.tenant}</td>
                  <td><code style={{ fontSize: 11, fontFamily: 'JetBrains Mono, monospace', color: 'var(--text-secondary)' }}>{e.endpoint}</code></td>
                  <td style={{ fontWeight: 700, color: e.status >= 500 ? 'var(--danger)' : 'var(--warning)', fontFamily: 'JetBrains Mono, monospace' }}>{e.status}</td>
                  <td style={{ fontSize: 12, color: 'var(--danger)', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{e.error}</td>
                  <td><code style={{ fontSize: 10, fontFamily: 'JetBrains Mono, monospace', color: 'var(--text-muted)' }}>{e.traceId}</code></td>
                  <td><span className="badge danger"><span className="dot" />{e.freq}x</span></td>
                  <td><div className="row-actions"><button className="icon-action" title="Detalhes"><Icon name="arrowRight" size={13} /></button></div></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {tab === 'perf' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
          <div className="card">
            <div className="card-head"><h3>Endpoints mais lentos (P99)</h3></div>
            <div className="card-body" style={{ padding: 0 }}>
              {TOP_ENDPOINTS.map((ep,i) => (
                <div key={i} style={{ padding: '12px 20px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 12 }}>
                  <div style={{ flex: 1 }}>
                    <code style={{ fontSize: 12, fontFamily: 'JetBrains Mono, monospace', color: 'var(--text)' }}>{ep.endpoint}</code>
                    <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>{ep.calls} requisições</div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--warning)' }}>{ep.p99}</div>
                    <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>P95: {ep.p95}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="card">
            <div className="card-head"><h3>Tenants mais lentos</h3></div>
            <div className="card-body" style={{ padding: 0 }}>
              {TENANT_HEALTH.filter(t => t.latency !== '—').sort((a,b) => parseInt(b.latency) - parseInt(a.latency)).map(t => (
                <div key={t.id} style={{ padding: '12px 20px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 12 }}>
                  <div style={{ flex: 1, fontSize: 13, fontWeight: 500 }}>{t.name}</div>
                  <div style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: 14, fontWeight: 700, color: parseInt(t.latency) > 200 ? 'var(--warning)' : 'var(--success)' }}>{t.latency}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Modals */}
      <ExportRelatorioModal open={exportOpen} onClose={() => setExportOpen(false)} onToast={onToast} lastExport={lastExport} setLastExport={setLastExport} />
      <ConfigAlertsDrawer open={alertsOpen} onClose={() => setAlertsOpen(false)} onToast={onToast} logAction={logAction} setAlertsLastUpdated={setAlertsLastUpdated} />
      <ServiceDiagnosticDrawer open={!!diagnosticSvc} svc={diagnosticSvc} onClose={() => setDiagnosticSvc(null)} onToast={onToast} />
      <PostmortemModal
        open={!!postmortemInc} inc={postmortemInc} onClose={() => setPostmortemInc(null)}
        onSave={(inc) => {
          setIncLocalStates(p => ({ ...p, [inc.id]: { ...p[inc.id], postmortem: true } }));
          setIncidents(prev => prev.map(i => i.id === inc.id ? { ...i, hasPostmortem: true } : i));
          onToast && onToast(`Postmortem salvo para ${inc.id}`);
          logAction && logAction({ acao: `Postmortem criado: ${inc.id}`, loja: '—', kind: 'info' });
        }}
      />
      <ExportIncidentModal open={!!exportInc} inc={exportInc} onClose={() => setExportInc(null)} onToast={onToast} />

      {/* Ações técnicas */}
      <RetryJobModal
        open={!!retryJob} task={retryJob} onClose={() => setRetryJob(null)}
        onConfirm={(task, ok) => {
          const key = task.task + '|' + task.tenant;
          setCeleryLocal(p => ({ ...p, [key]: { status: ok ? 'success' : 'failure' } }));
          logAction && logAction({ acao: `Retry de ${task.task}: ${ok ? 'Sucesso' : 'Falha'}`, loja: task.tenant, kind: ok ? 'info' : 'danger' });
          onToast && onToast(`Retry de ${task.task}: ${ok ? 'Concluído' : 'Falhou novamente'}`);
        }}
      />
      <TechActionModal
        open={!!clearCacheModal}
        onClose={() => setClearCacheModal(null)}
        title={clearCacheModal?.type === 'global' ? 'Limpar cache global' : `Limpar cache`}
        icon="zap" iconBg="var(--info-bg)" iconColor="var(--info)"
        body={clearCacheModal?.type === 'global'
          ? 'O cache Redis global será completamente invalidado. As próximas requisições reconstruirão o cache automaticamente.'
          : `O cache Redis de ${clearCacheModal?.name} será invalidado. As próximas requisições reconstruirão o cache automaticamente.`}
        progressLabel="Limpando cache…"
        successLabel={clearCacheModal?.type === 'global' ? 'Cache global limpo!' : 'Cache limpo!'}
        onConfirm={() => {
          const name = clearCacheModal?.name;
          setCacheCleared(p => ({ ...p, [name]: true }));
          logAction && logAction({ acao: `Cache limpo: ${name}`, loja: name === 'Redis Global' ? '—' : name, kind: 'info' });
          onToast && onToast(`Cache de ${name} limpo`);
        }}
      />
      <TechActionModal
        open={!!reindexModal}
        onClose={() => setReindexModal(null)}
        title="Reindexar"
        icon="search" iconBg="var(--info-bg)" iconColor="var(--info)"
        body={`O índice OpenSearch de ${reindexModal?.name} será recriado. A busca pode ficar brevemente indisponível durante o processo.`}
        progressLabel="Reindexando…"
        successLabel="Reindexado com sucesso!"
        onConfirm={() => {
          const { name, tenantId } = reindexModal || {};
          setReindexDone(p => ({ ...p, [tenantId]: true }));
          logAction && logAction({ acao: `Busca reindexada: ${name}`, loja: name, kind: 'info' });
          onToast && onToast(`${name} reindexado com sucesso`);
        }}
      />
      <CleanOrphansModal
        open={orphansModal} count={orphanCount}
        onClose={() => setOrphansModal(false)}
        onConfirm={() => {
          const removed = orphanCount;
          setOrphanCount(0);
          logAction && logAction({ acao: `${removed} arquivos órfãos removidos`, loja: '—', kind: 'info' });
          onToast && onToast(`${removed} arquivos órfãos removidos do storage`);
        }}
      />
      <TestUploadModal
        open={uploadModal}
        onClose={() => setUploadModal(false)}
        onToast={onToast}
      />
    </div>
  );
};

export {
  ObservabilidadePage,
};
